import { render } from "./pageConfig.vue?vue&type=template&id=fba1eaf2"
import script from "./pageConfig.vue?vue&type=script&lang=js"
export * from "./pageConfig.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/page/pageConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fba1eaf2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fba1eaf2', __exports__)) {
    console.log('reload')
    api.reload('fba1eaf2', __exports__)
  }
  
  module.hot.accept("./pageConfig.vue?vue&type=template&id=fba1eaf2", () => {
    console.log('re-render')
    api.rerender('fba1eaf2', render)
  })

}


export default __exports__